<script lang="ts">
	import MetaTags from '$lib/components/utils/MetaTags.svelte';
	import ResponsiveWrapper from '$lib/components/utils/ResponsiveWrapper.svelte';
	import Tag from '$lib/components/utils/tag.svelte';
	import date from 'date-and-time';

	import icoPencil from 'iconoir/icons/edit-pencil.svg';

	/** @type {import('./$types').PageData} */
	export let data;

	const documentObject = data.documentObject;

	let truncPostTitle = '';
	if (documentObject.postTitle.length > 30) {
		truncPostTitle = documentObject.postTitle.substring(0, 30) + '...';
	} else {
		truncPostTitle = documentObject.postTitle;
	}

	const publishedDate = new Date(documentObject.postPublishedDate);
	const modifiedDate = new Date(documentObject.postModifiedDate);
	const shortModifiedDate = date.format(modifiedDate, "DD MMM YY'");
	const longModifiedDate = date.format(modifiedDate, 'DD MMMM YYYY');
	const longPublishedDate = date.format(publishedDate, 'DD MMMM YYYY');

	import checkPerm from '../../../lib/components/auth/getPermissions.js';

	async function canEdit() {
		return await checkPerm('edit-news');
	}
</script>

<MetaTags title={truncPostTitle} />

<ResponsiveWrapper title={truncPostTitle}>
	<div
		class="mt-8 rounded bg-white dark:bg-zinc-800 md:mt-0 md:bg-transparent dark:md:bg-transparent"
		itemscope
		itemtype="https://schema.org/NewsArticle"
	>
		<div class="p-2 md:p-0 md:pt-8">
			<div class="md:hidden">
				<h2 class="text-xl" itemprop="headline">{documentObject.postTitle}</h2>
			</div>
			<meta itemprop="image" content={documentObject.postImgLink} />
			<img
				src={documentObject.postImgLink}
				alt={documentObject.postImgAlt}
				class="h-64 w-full rounded object-cover"
				style="object-position: {documentObject.postImgFocal}"
			/>
			<div class="">
				<div class="-my-8 mb-4 ml-2 flex flex-wrap gap-x-2 text-xs text-white">
					<Tag content="Latest News" />
					<Tag content={documentObject.userName} itemprop="name" class="hidden md:block" />
					<Tag content={shortModifiedDate} itemprop="dateModified" />
				</div>
				<div>
					{#await canEdit()}
						<div />
					{:then result}
						{#if result == true}
							<a href="/news/{documentObject._id}/edit" class="float-right px-2 py-0.5">
								<div
									class="grid grid-cols-2 items-center gap-x-1.5 text-sm text-zinc-800 dark:text-zinc-200"
								>
									<img
										src={icoPencil}
										alt="Edit Icon"
										class="inline-block h-4 w-4 justify-self-end"
									/>
									<p>Edit</p>
								</div>
							</a>
						{/if}
					{/await}
				</div>
				<h2 class="text-xl">{documentObject.postTitle}</h2>
			</div>
			<div class="pt-2">
				<p class="text-sm italic text-zinc-800">{documentObject.postSummary}</p>
				<div class="my-2 w-full border-b-[1px] border-zinc-100" />
				<p class="whitespace-pre-wrap">{documentObject.postBody}</p>
			</div>
			<div class="mt-8 text-center text-sm text-zinc-700 dark:text-zinc-300 md:text-left">
				<p class="inline-block" itemprop="datePublished" content={publishedDate}>
					Published: {longPublishedDate}
				</p>
				<p class="hidden md:inline-block">&bullet;</p>
				<p class="inline-block" itemprop="dateModified" content={modifiedDate}>
					Last Modified: {longModifiedDate}
				</p>
			</div>
		</div>
	</div>
	<p class="mt-8 text-center text-xs text-zinc-600 dark:text-zinc-400 md:mt-0 md:text-left">
		Debug ID: {documentObject._id}
	</p>
</ResponsiveWrapper>
